import newslettersIcon from "../../../images/icons/sidebar-newsletters.svg";
import spikingSystemIcon from "../../../images/icons/sidebar-spiking-system.svg";
import upgradeToPremiumIcon from "../../../images/icons/sidebar-upgrade-to-premium.svg";
import coursesIcon from "../../../images/icons/sidebar-courses.svg";
import optionsTradingIcon from "../../../images/icons/sidebar-options-trading.svg";
import advancedOptionsIcon from "../../../images/icons/sidebar-advanced-options.svg";
import calendarIcon from "../../../images/icons/sidebar-calendar.svg";
import goalsIcon from "../../../images/icons/sidebar-goals.svg";
import homeIcon from "../../../images/icons/sidebar-home.svg";
import stocksIcon from "../../../images/icons/sidebar-stocks.svg";
import analysisIcon from "../../../images/icons/sidebar-analysis.svg";
import portfoliosIcon from "../../../images/icons/sidebar-portfolios.svg";
import insiderInvestorsIcon from "../../../images/icons/sidebar-insider-investors.svg";
import activeTradersIcon from "../../../images/icons/sidebar-active-traders.svg";
import aiIcon from "../../../images/icons/sidebar-ai.svg";
import topRankingIcon from "../../../images/icons/sidebar-top-ranking.svg";
import bitcoinIcon from "../../../images/icons/sidebar-bitcoin.svg";
import startFreeIcon from "../../../images/icons/sidebar-start-free.svg";
import resourcesIcon from "../../../images/icons/sidebar-resources.svg";

export const menuItems = [
   {
    label: 'Start FREE Now',
    to: '/login',
    showIcon: true,
    iconImage: startFreeIcon,
    requiresGuest: true,
  },
  {
    label: "Spiking System",
    to: "https://spiking.com/system",
    showIcon: true,
    iconImage: spikingSystemIcon,
    openInNewTab: false,
  },
  {
    label: "Newsletters",
    to: "/newsletter",
    showIcon: true,
    iconImage: newslettersIcon,
    freeBadge: true,
  },
  {
    label: "Education",
    isSection: true,
    sectionVariant: "muted",
    children: [
      {
        label: "Courses",
        showIcon: true,
        iconImage: coursesIcon,
        children: [
          { label: "Masterclass", to: "/courses#masterclass" },
          { label: "Options Trading", to: "/courses#options" },
          { label: "US Stock Market", to: "/courses#epic" },
          { label: "Trade Thru The Night", to: "/courses#tttn" },
        ],
      },
      {
        label: "Calendar",
        to: "/calendar",
        showIcon: true,
        iconImage: calendarIcon,
      },
      {
        label: "Goals",
        to: "/profile/harada-method",
        showIcon: true,
        iconImage: goalsIcon,
      },
    ],
  },
  {
    id: "home",
    label: "Home",
    to: "https://spiking.com/",
    showIcon: true,
    openInNewTab: false,
    iconImage: homeIcon,
    isSection: true,
    children: [
      {
        label: "Stocks",
        showIcon: true,
        iconImage: stocksIcon,
        children: [
          {
            label: "Spiking Up",
            subLabel: "Intraday",
            to: "/spiking-up-down",
          },
          {
            label: "Daily Bread",
            subLabel: "1-Day",
            to: "/stocks/dailybread",
          },
          {
            label: "Resurrection",
            subLabel: "1-Month",
            to: "/stocks/resurrection?tags=net_positive_purchase",
          },
          {
            label: "Triangulation",
            subLabel: "1-Quarter",
            to: "/stocks/triangulation?tags=net_positive_purchase",
          },
          {
            label: "Trillion",
            subLabel: "1-Year",
            to: "/stocks/trillion",
          },
        ],
      },
      {
        label: "Properties",
        showIcon: true,
        iconImage: topRankingIcon,
        children: [
          { label: "Launches", subLabel: "P1", to: "/property/tools/launches" },
          { label: "HDB or Private", subLabel: "P2", to: "/property/tools/split" },
          { label: "BTO or Resales", subLabel: "P3", to: "/property/tools/fork" },
          { label: "Awards", subLabel: "P4", to: "/property/tools/awards" },
          { label: "Archive", subLabel: "P5", to: "/property/tools/archive" },
        ],
      },
      {
        label: "Options Trading",
        showIcon: true,
        iconImage: optionsTradingIcon,
        children: [
          { label: "Open Interest", to: "/options/open-interest" },
          { label: "IV Change", to: "/options/iv-change" },
          { label: "Block Quantity", to: "/options/block-quantity" },
          { label: "Block Quality", to: "/options/block-quality" },
          { label: "Qty % Avg Volume", to: "/options/avg-volume" },
        ],
      },
      {
        label: "Bitcoin",
        showIcon: true,
        iconImage: bitcoinIcon,
        children: [
          { label: "Whale Watch", subLabel: "Intraday", to: "/crypto/tools/whales" },
          { label: "ETF Tape", subLabel: "1-Day", to: "/crypto/tools/etf" },
          { label: "Miner Pulse", subLabel: "1-Month", to: "/crypto/tools/miners" },
          { label: "Treasury Ledger", subLabel: "1-Quarter", to: "/crypto/tools/treasury" },
          { label: "Gold Parity", subLabel: "1-Year", to: "/crypto/tools/gold" },
        ],
      },
      {
        label: "Advanced Options",
        showIcon: true,
        iconImage: advancedOptionsIcon,
        children: [
          {
            label: "56 Strategies",
            to: "https://spiking.com/56",
            openInNewTab: true,
          },
          {
            label: "Manual",
            to: "https://spiking.com/56/manual",
            openInNewTab: true,
          },
          {
            label: "1. AI Chokepoint",
            to: "https://spiking.com/options-1",
            openInNewTab: true,
          },
          {
            label: "2. Summit Wiring",
            to: "https://spiking.com/options-2",
            openInNewTab: true,
          },
          {
            label: "3. Peak Earnings",
            to: "https://spiking.com/options-3",
            openInNewTab: true,
          },
        ],
      },
      {
        label: "Analysis",
        showIcon: true,
        iconImage: analysisIcon,
        children: [
          {
            label: "FIAT Method",
            subLabel: "Equities",
            to: "/company/fundamentals/13811/calls?date=",
          },
          {
            label: "LAND Method",
            subLabel: "Properties",
            to: "/property/land",
            matchRoutes: ["/property/agents", "/property/launches", "/property/decision"],
          },
          {
            label: "TIME Method",
            subLabel: "Income",
            to: "/options/company/territory/12903",
          },
          {
            label: "HODL Method",
            subLabel: "Crypto",
            to: "/crypto/hodl/halving",
            matchRoutes: ["/crypto/hodl/on-chain", "/crypto/hodl/dominance", "/crypto/hodl/liquidity"],
          },
        ],
      },
      {
        label: "Portfolios",
        showIcon: true,
        iconImage: portfoliosIcon,
        children: [
          { label: "AI", to: "/holygrail-ai?portfolio_id=1" },
          { label: "Cryptos", to: "/holygrail-cryptos?portfolio_id=1" },
          { label: "Options", to: "/holygrail-options?portfolio_id=1" },
          { label: "Stocks", to: "/holygrail?portfolio_id=1" },
          { label: "Wealth", to: "/holygrail-wealth?portfolio_id=1" },
        ],
      },
      {
        label: "Insider Investors",
        showIcon: true,
        iconImage: insiderInvestorsIcon,
        children: [
          {
            label: "Top 100",
            subLabel: "Money Manager",
            to: "/funds/top100/fundamental",
          },
          {
            label: "Universe",
            subLabel: "Fund",
            to: "/funds/universe/fundamental",
          },
          {
            label: "Sovereign Wealth",
            subLabel: "Fund",
            to: "/funds/sovereign/fundamental",
          },
          {
            label: "Pension",
            subLabel: "Fund",
            to: "/funds/pension/fundamental",
          },
          {
            label: "Retirement",
            subLabel: "Fund",
            to: "/funds/retirement/fundamental",
          },
          {
            label: "C-Suite",
            subLabel: "Management",
            to: "/funds/csuite/insider",
          },
          {
            label: "Politician",
            subLabel: "Senate & Congress",
            to: "/funds/politicians",
          },
          { label: "CNBC", subLabel: "Guest", to: "/funds/cnbc" },
        ],
      },
      {
        label: "Active Traders",
        showIcon: true,
        iconImage: activeTradersIcon,
        children: [
          {
            label: "Cathie Wood",
            to: "/investor/ark/fundamental",
            subLabel: "Aggressive",
          },
          {
            label: "Warren Buffett",
            to: "/investor/warren/fundamental",
            subLabel: "Moderate",
          },
          {
            label: "Temasek Holdings",
            to: "/investor/temasek/fundamental",
            subLabel: "Conservative",
          },
        ],
      },
      {
        label: "AI",
        showIcon: true,
        iconImage: aiIcon,
        children: [
          {
            label: "SpikingAI®",
            to: "/spikingai-login",
            openInNewTab: true,
            hideInCordova: true,
          },
          { label: "Prompt", to: "/prompt", openInNewTab: true },
        ],
      },
      {
        label: "Top Ranking",
        showIcon: true,
        iconImage: topRankingIcon,
        children: [
          { label: "Top 10 Buy/Sell", to: "/top-10-buy" },
          { label: "Top 30 AI Stocks", to: "/top-30-ai-stocks" },
          { label: "Top 200 SMA", to: "/200-sma" },
          { label: "YTD Stock Performance", to: "/stock-performance" },
        ],
      },
      {
        label: "Resources",
        to: "https://spiking.com/resources",
        showIcon: true,
        iconImage: resourcesIcon,
        openInNewTab: false,
      },
    ],
  },
];
